import { useSelector } from "react-redux";
import { usePawsBraintreeCC } from "@urp/amplitude-experiments";
import { getBraintreeCCToggle } from "../redux/toggles";

/**
 * Returns `{ isEnabled, isResolved }` where `isEnabled` is true only when
 * the SGW `pawsBraintreeCC` kill-switch is on AND the user is in the Amplitude
 * treatment group. `isResolved` represents the combined gate resolution: it is
 * false while the experiment fetch is in flight (only when SGW is ON), and true
 * immediately when SGW is OFF since no experiment fetch is needed. Callers
 * should defer side-effects until `isResolved` is true.
 */
export const useIsBraintreeEnabled = (): {
  isEnabled: boolean;
  isResolved: boolean;
} => {
  const isSgwBraintreeEnabled = useSelector(getBraintreeCCToggle);
  const { isTreatment, isResolved } = usePawsBraintreeCC();

  if (!isSgwBraintreeEnabled) return { isEnabled: false, isResolved: true };
  return { isEnabled: isTreatment, isResolved };
};

export default useIsBraintreeEnabled;
